import { createBrowserRouter, useLocation } from "react-router-dom";
import Login from "./Login";
import ClientBranding from "./ClientBranding";
import { RouterProvider } from "react-router-dom";
import Dashboard from "./Dashboard";
import SignIn from "./Signin";
import PropertyForm from "./PropertyForm";
import NotFound from "./NotFound";
import PropertyViewDetails from "./PropertyViewDetails";
import MyBooking from "./MyBooking";
import Approval from "./Approval";
import ApprovalApproverdash from "./ApprovalApproverdash";
import ViewSurvey from "./ViewSurvey";
import ViewSurveyAnonymous from "./ViewSurveyAnonymous";
import HtmlQrCodeScannerComponent from "../components/common/Html5QrcodeScannerComponent";
import ClientDashboard from "./ClientDashboard";
import Members from "./Members";
import RoleBasedRoute from "./RoleBasedRoute";
import Subscription from "./Subscription";
import RegisterUser from "./RegisterUser";
import AddProperty from "./AddProperty";
import InviteNewMember from "./InviteNewMember";
import SuccessPage from "./common/SuccessPage";
import FailurePage from "./common/FailurePage";
import Inspections from "./NewInspection/Inspections";
import PorpertyInspectionsHistory from "./PropertyInspectionsHistory";
import NewInspection from "./NewInspection/NewInspection";
import LeadDashboard from "./LeadDashboard";
import SendBookingLink from "./SendBookingLink";
import ScheduleInspection from "./NewInspection/ScheduleInspection";
import AdminDashboard from "./AdminDashboard";
import BookingHistory from "./bookinghistory";
import AuditTrail from "./AuditTrail";
import QrAuditTrail from "./QrAuditTrail";
import Generateor from "./GenerateOR";
import LinkQRcode from "./LinkQRCodes";
import ValidateClient from "./validateclient";
import ScanLinkQRCode from "./ScanLinkQRCode";
import Policy from "./Policy";
import AuthenticatedLayout from "./AuthenticatedLayout";
import ViewAction from "./ViewAction";
import ActionRemediation from "./ActionRemediation";
import UserProfile from "./UserProfile";
import PropertyList from "./Property/Property";
// import Calendar from "./InspectionCalendar";
import Calendar from "./InspectionCalendar";
import AuditTrailPDF from "./AuditTrailPdF";
import ResidentLog from "./ResidentLog";
import ViewAllReport from "./ViewAllReport";
import ApproverDashboard from "./ApproverDashboard";
function KeyedPropertyViewDetails() {
  const { pathname } = useLocation();
  return <PropertyViewDetails key={pathname} />;
}

const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/api/Anonymous/qref/:token",
      element: <AuditTrailPDF />,
    },
    {
      path: "/PrivacyPolicy",
      element: <Policy />,
    },
      
    {
          path: "/client/:clientNameParam/viewSurveyAnonymous/:propertyMasterId/:inspectionRefnumber/:doorRefNumber",     
            element: <ViewSurveyAnonymous />,
     },
    {
      path: "/client",
      element: <Login />,
    },
    // {
    //   path: "/client/:clientNameParam",
    //   element: <Login />,
    // },
    {
      path: "/client/:clientNameParam",
      element: (
        <ValidateClient>
          <Login />
        </ValidateClient>
      ),
    },
    {
      path: "/client/:clientNameParam/signin",
      element: <SignIn />,
    },
    {
      path: "/client/:clientNameParam/QRCode/linkqrcode",
      element: (
        <ValidateClient>
          <LinkQRcode />
        </ValidateClient>
      ),
    },
    {
      element: <AuthenticatedLayout />,
      children: [
        {
          path: "/client/:clientNameParam/register",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <RegisterUser />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/ClientBranding",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <ClientBranding />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/UserProfile",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <UserProfile />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/viewAction",
          element: (
            <RoleBasedRoute allowedRoles={[1, 3]}>
              <ViewAction />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/actionRemediation",
          element: (
            <RoleBasedRoute allowedRoles={[1, 3]}>
              <ActionRemediation />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/BookingHistory/:inspectionMasterId/:propertyMasterId",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <BookingHistory />
            </RoleBasedRoute>
          ),
        },

        {
          path: "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <Dashboard />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber/:doorRefNumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <Dashboard />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <ScanLinkQRCode />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/viewSurvey/:propertyMasterId/:inspectionRefnumber/:doorRefNumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <ViewSurvey />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/AuditTrail/:propertyMasterId/:inspectionRefnumber/:doorRefNumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <AuditTrail />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/QrAuditTrail/:doorRefNumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <QrAuditTrail />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/editSurvey/:propertyMasterId/:inspectionRefnumber/:doorRefNumber",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <ViewSurvey />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/approval/:propertyMasterId",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <Approval />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/approval/:propertyMasterId",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <ApprovalApproverdash />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/property-form",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <PropertyForm />
            </RoleBasedRoute>
          ),
        },

        {
          path: "/client/:clientNameParam/approverDashboard",
          element: (
            <RoleBasedRoute allowedRoles={[3]}>
              <ApproverDashboard />
            </RoleBasedRoute>
          ),
        },

        {
          path: "/client/:clientNameParam/QRCodes",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <Generateor />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber",
          element: <KeyedPropertyViewDetails />,
        },
        {
          path: "/client/:clientNameParam/scanDoor",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2, 3]}>
              <HtmlQrCodeScannerComponent />
            </RoleBasedRoute>
          ),
        },

        {
          path: "/client/:clientNameParam/myBooking",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <MyBooking />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/clientDashboard",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <ClientDashboard />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/addProperty",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <AddProperty />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/subscription",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <Subscription />
            </RoleBasedRoute>
          ),
        },

        {
          path: "/client/:clientNameParam/members",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <Members />
            </RoleBasedRoute>
          ),
        },

        {
          path: "/client/:clientNameParam/inviteNewMember",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <InviteNewMember />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/paymentSuccess",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <SuccessPage />
            </RoleBasedRoute>
          ),
        },
         {
          path: "/client/:clientNameParam/viewAllReport",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <ViewAllReport />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/paymentCancelled",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <FailurePage />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/inspectionDashboard",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <Inspections />
            </RoleBasedRoute>
          ),
        },
          {
          path: "/client/:clientNameParam/viewInspectionHistory/:propertyMasterId",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <PorpertyInspectionsHistory />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/inspection",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <NewInspection />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/inspection/:inspectionMasterId",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <NewInspection />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/scheduleInspection/:inspectionMasterId",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <ScheduleInspection />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/map",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <PropertyList />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/leadDashboard",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <LeadDashboard />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/sendBookingLink",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <SendBookingLink />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/residentLog",

          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <ResidentLog />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/adminDashboard",
          element: (
            <RoleBasedRoute allowedRoles={[1]}>
              <AdminDashboard />
            </RoleBasedRoute>
          ),
        },
        {
          path: "/client/:clientNameParam/calendar",
          element: (
            <RoleBasedRoute allowedRoles={[1, 2]}>
              <Calendar />
            </RoleBasedRoute>
          ),
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return (
    <div>
      <div>
        <RouterProvider router={appRouter} />
      </div>
    </div>
  );
};
export default Body;
